import type { MisconceptionDefinition } from '../types';
export const basisLeenwoordenMisconceptions: MisconceptionDefinition[] = [{
  id: 'sww.kofschip-misapplied',
  label: 'Kofschip verkeerd toegepast',
  module: 'SpellingWW',
  description: 'Umbrella-tag: leerling kiest de verkeerde kofschip-uitgang (-t vs -d, -te vs -de, -ten vs -den) bij voltooid deelwoord of zwakke verleden tijd. Voor specifieke oorzaken zie sww.kofschip-on-stem-not-infinitive (op infinitief i.p.v. stam) of sww.kofschip-letter-not-sound (op letter i.p.v. klank).',
  typicalFamilies: ['SWW-VD-KOF', 'SWW-VT-ZWAK-KOF', 'SWW-LEEN-ENG-KOF', 'SWW-LEEN-FRANS', 'SWW-VT-DUBBEL']
}, {
  id: 'sww.stem-extraction-error',
  label: 'Stam verkeerd bepaald',
  module: 'SpellingWW',
  description: 'Leerling bepaalt de stam van het werkwoord verkeerd: ofwel de stam-letter wordt vervangen (v↔f, z↔s) waar dat niet hoort (bv. "leven" → stam "leev" terwijl "leef" correct is), ofwel een hele letter wordt weggelaten of toegevoegd. De fout treedt op vóór de kofschip-check, waardoor ook de uitgang verkeerd uitvalt.',
  typicalFamilies: ['SWW-TT-STAM', 'SWW-TT-DSTAM', 'SWW-VT-VZFS']
}, {
  id: 'sww.past-participle-ge-omitted',
  label: 'Ge- weggelaten',
  module: 'SpellingWW',
  description: 'Leerling vergeet ge- bij het voltooid deelwoord (of voegt het onterecht toe).',
  typicalFamilies: ['SWW-VD-ZONDER-GE']
},
// NOTE: 'sww.irregular-verb-regularized' (EN-legacy) is GEMIGREERD (juni 2026)
// naar de bestaande Nederlandse canonieke ID 'sww.onregelmatig-als-regelmatig'
// (zie ./onregelmatigSterk.ts). De Engelse duplicaat is hier verwijderd; alle
// seeds verwijzen nu naar de NL-ID. De semantiek is identiek (regelmatige
// regel toegepast op onregelmatig werkwoord).
// === Leenwoorden (Engels / Frans) ===
{
  id: 'sww.loanword-spelling-stripped',
  label: 'Engelse/Franse spelling uit stam weggelaten',
  module: 'SpellingWW',
  description: 'Leerling verwijdert delen van de oorspronkelijke spelling (bv. eind-"e", dubbele letter) van de stam van een leenwoord.',
  typicalFamilies: ['SWW-LEEN-ENG-STAM', 'SWW-LEEN-ENG-KOF', 'SWW-LEEN-FRANS']
}, {
  id: 'sww.loanword-vowel-doubled',
  label: 'Klinker verdubbeld volgens Nederlandse regel',
  module: 'SpellingWW',
  description: 'Leerling verdubbelt een klinker in de stam van een leenwoord volgens Nederlandse open/gesloten lettergreepregels, terwijl de leenwoordspelling behouden moet blijven.',
  typicalFamilies: ['SWW-LEEN-ENG-STAM']
}, {
  id: 'sww.stem-with-extra-letter',
  label: 'Extra letter toegevoegd aan stam',
  module: 'SpellingWW',
  description: 'Leerling voegt een extra letter toe aan de werkwoordstam (bv. extra "e" of medeklinker).',
  typicalFamilies: ['SWW-LEEN-ENG-STAM']
}, {
  id: 'sww.loanword-double-consonant-lost',
  label: 'Dubbele medeklinker vernederlandst (enkel gemaakt)',
  module: 'SpellingWW',
  description: 'Leerling maakt een dubbele medeklinker in de leenwoord-stam enkel volgens NL-spelling.',
  typicalFamilies: ['SWW-LEEN-ENG-STAM', 'SWW-LEEN-FRANS']
}, {
  id: 'sww.stem-extra-e-added',
  label: 'Extra -e toegevoegd aan stam',
  module: 'SpellingWW',
  description: 'Leerling voegt een overbodige -e toe aan de stam (bv. "racee" i.p.v. "race").',
  typicalFamilies: ['SWW-LEEN-ENG-STAM']
}, {
  // GEMIGREERD (juni 2026): was 'sww.infinitive-instead-of-stem' (EN-legacy).
  id: 'sww.infinitief-ipv-stam',
  label: 'Hele werkwoord gebruikt i.p.v. stam',
  module: 'SpellingWW',
  description: 'Leerling gebruikt het hele werkwoord (infinitief, -en vorm) op een plek waar de stam hoort.',
  typicalFamilies: ['SWW-LEEN-ENG-STAM', 'SWW-TT-STAM']
}, {
  id: 'sww.noun-instead-of-stem',
  label: 'Zelfstandig naamwoord i.p.v. werkwoordstam',
  module: 'SpellingWW',
  description: 'Leerling gebruikt een zelfstandig naamwoord (bv. "race") op een plek waar de werkwoordstam ("racet/racete") hoort.',
  typicalFamilies: ['SWW-LEEN-ENG-STAM']
}, {
  id: 'sww.loanword-english-grammar',
  label: 'Engelse grammatica toegepast op leenwoord',
  module: 'SpellingWW',
  description: 'Leerling gebruikt Engelse uitgangen (bv. -ed) i.p.v. Nederlandse vervoegingsuitgangen bij Engelse leenwoorden.',
  typicalFamilies: ['SWW-LEEN-ENG-STAM', 'SWW-LEEN-ENG-KOF']
}, {
  id: 'sww.loanword-spelling-dutchified',
  label: 'Leenwoord-spelling vernederlandst',
  module: 'SpellingWW',
  description: 'Leerling past Nederlandse spellingregels toe op de stam van een leenwoord (bv. "save" → "seef", "ç" → "s").',
  typicalFamilies: ['SWW-LEEN-ENG-STAM', 'SWW-LEEN-ENG-KOF', 'SWW-LEEN-FRANS']
}, {
  id: 'sww.stem-d-lost',
  label: 'Stam-d weggelaten in uitgang',
  module: 'SpellingWW',
  description: 'Leerling laat de stam-d weg bij vervoeging (bv. "hij race" i.p.v. "hij raced").',
  typicalFamilies: ['SWW-LEEN-ENG-KOF', 'SWW-VT-ZWAK-KOF']
}, {
  id: 'sww.infinitive-after-aux',
  label: 'Infinitief gebruikt na hulpwerkwoord i.p.v. VD',
  module: 'SpellingWW',
  description: 'Leerling gebruikt het hele werkwoord (infinitief) na een hulpwerkwoord, terwijl het voltooid deelwoord vereist is.',
  typicalFamilies: ['SWW-VD-HULPWW']
}, {
  id: 'sww.noun-verb-confusion',
  label: 'Zelfstandig naamwoord verward met werkwoord',
  module: 'SpellingWW',
  description: 'Leerling verwart een zelfstandig naamwoord (bv. "belofte") met een verleden-tijdsvorm.',
  typicalFamilies: ['SWW-VT-VZFS']
}];